// ============================================================
// FILE: assets/theme-jquery.js
// Include karo theme.liquid mein:
// <script src="{{ 'theme-jquery.js' | asset_url }}" defer="defer"></script>
// ============================================================

$(document).ready(function () {

  // -----------------------------------------------------------
  // 1. ARTICLE READ MORE / READ LESS BUTTON
  // Was: theme.liquid (near bottom, after Meta Pixel section)
  // Condition: Har page par load hota tha — ab bhi hoga (global)
  // -----------------------------------------------------------
  $(".article-read-more-btn").click(function () {
    var parent = $(this).closest(".article-wrapper");
    var content = parent.find(".article-content");

    content.toggleClass("expanded");

    if (content.hasClass("expanded")) {
      $(this).text("READ LESS");
    } else {
      $(this).text("READ MORE");
    }
  });


  // -----------------------------------------------------------
  // 2. FLOATING SHOPPER LINK — SCROLL SHOW/HIDE (Hero section)
  // Was: theme.liquid <body> start
  // Condition: index, page, collection templates par
  // -----------------------------------------------------------
  var bodyClass = document.body.className;
  var isIndexOrPageOrCollection =
    bodyClass.includes("index") ||
    bodyClass.includes("page") ||
    bodyClass.includes("collection");

  if (isIndexOrPageOrCollection) {
    $(window).scroll(function () {
      var heroElement = $(".hero__bg-wrapper");
      if (heroElement.length === 0) return;

      var scrollPosition = $(window).scrollTop();
      var elementOffset = heroElement.offset().top;
      var targetPosition = elementOffset + 400;

      if (scrollPosition >= targetPosition) {
        $(".shopperlink.floating").addClass("show");
      } else {
        $(".shopperlink.floating").removeClass("show");
      }
    });
  }


  // -----------------------------------------------------------
  // 3. MOBILE FLOATING BADGE — FADE IN/OUT ON SCROLL
  // Was: theme.liquid (last <script> block before </body>)
  // Condition: Mobile only (<=767px)
  // -----------------------------------------------------------
  if ($(window).width() <= 767) {
    $(".shopperlink.new-sa-seals.floating").hide();

    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 400) {
        $(".shopperlink.new-sa-seals.floating").fadeIn();
      } else {
        $(".shopperlink.new-sa-seals.floating").fadeOut();
      }
    });
  }

});
